<template>
  <div>
    <BlockUI v-if="loading"></BlockUI>
    <TituloComponent icono-titulo="fas fa-users" texto-titulo="Modificar cliente"></TituloComponent>
    <div class="main-card mb-3 card col-12">
      <div class="card-body">
        <form @submit.prevent="guardarCliente()">
          <div class="row">
            <float-label label="Nombre" clase="col-12">
              <input v-model="cliente.nombre" id="nombre" placeholder="Nombre" type="text" class="form-control" :class="(enviado && !$v.cliente.nombre.required) ? 'is-invalid' : ''" />
              <template v-slot:validation >
                <div class="invalid-feedback" v-if="enviado && !$v.cliente.nombre.required">Nombre requerido</div>
              </template>
            </float-label>
            <float-label label="N° documento:" clase="col-12">
              <input v-model="cliente.numero_documento" id="numero_documento" placeholder="99999999" inputmode="numeric" type="text" class="form-control" :class="(enviado && !$v.cliente.numero_documento.numeric) ? 'is-invalid' : ''"/>
              <template v-slot:validation >
                <div class="invalid-feedback" v-if="enviado && !$v.cliente.numero_documento.numeric">Usar solo números</div>
              </template>
            </float-label>
            <float-label label="Domicilio:" clase="col-12">
              <input v-model="cliente.domicilio" id="domicilio" placeholder="Domicilio" type="text" class="form-control"/>
            </float-label>
            <float-label label="Localidad:" clase="col-12">
              <input v-model="cliente.localidad" id="localidad" placeholder="Localidad" type="text" class="form-control"/>
            </float-label>
            <float-label label="Código postal:" clase="col-12">
              <input v-model="cliente.codigo_postal" id="codigo_postal" placeholder="Cod. Postal" inputmode="numeric" type="text" class="form-control" :class="(enviado && !$v.cliente.codigo_postal.numeric) ? 'is-invalid' : ''"/>
              <template v-slot:validation >
                <div class="invalid-feedback" v-if="enviado && !$v.cliente.codigo_postal.numeric">Usar solo números</div>
              </template>
            </float-label>
            <float-label label="Teléfono:" clase="col-12">
              <input v-model="cliente.telefono" id="telefono" placeholder="Teléfono" type="text" class="form-control"/>
            </float-label>
            <float-label label="Empleado:" clase="col-12">
              <select v-model="cliente.user_id" id="user_id" class="form-control" :class="(enviado && !$v.cliente.user_id.required) ? 'is-invalid' : ''">
                  <option value="null">Seleccione una opción</option>
                  <option v-for="user in users" :key="user.id" :value="user.id">{{user.nombre}}</option>
              </select>
              <template v-slot:validation >
                <div class="invalid-feedback" v-if="enviado && !$v.cliente.user_id.required">Seleccionar IVA</div>
              </template>
            </float-label>
            <float-label label="IVA:" clase="col-12">
              <select v-model="cliente.responsabilidad_iva_id" id="responsabilidad_iva_id" class="form-control" :class="(enviado && !$v.cliente.responsabilidad_iva_id.required) ? 'is-invalid' : ''">
                  <option value="null">Seleccione una opción</option>
                  <option v-for="iva in responsabilidadesIva" :key="iva.id" :value="iva.id">{{iva.descripcion}}</option>
              </select>
              <template v-slot:validation >
                <div class="invalid-feedback" v-if="enviado && !$v.cliente.responsabilidad_iva_id.required">Seleccionar IVA</div>
              </template>
            </float-label>
            <float-label label="Lista:" clase="col-12">
              <select v-model="cliente.lista_id" id="lista_id" class="form-control" :class="(enviado && !$v.cliente.lista_id.required) ? 'is-invalid' : ''">
                  <option value="null">Seleccione una opción</option>
                  <option v-for="lista in listas" :key="lista.id" :value="lista.id">{{lista.descripcion}}</option>
              </select>
              <template v-slot:validation >
                <div class="invalid-feedback" v-if="enviado && !$v.cliente.lista_id.required">Seleccionar Lista</div>
              </template>
            </float-label>
          </div>
          <button class="mt-1 btn btn-info float-right">Guardar</button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponent";
import BlockUI from "@/components/loaders/BlockUI";
import { required, numeric} from 'vuelidate/lib/validators';
import FloatLabel from "@/components/layouts/FloatLabel";
import axios from "axios";
import Swal from "sweetalert2";
import Cliente from "@/models/cliente";
export default {
  name: "NuevaMarca",
  components: {
    TituloComponent,
    BlockUI,
    FloatLabel
  },
  data() {
    return {
      cliente: new Cliente(null, "", null, "", "", null, null, "", null, null),
      responsabilidadesIva: [],
      listas: [],
      users:[],
      loading: false,
      enviado:false
    };
  },
  validations:{
    cliente:{
      nombre:{required},
      numero_documento:{numeric},
      codigo_postal:{numeric},
      responsabilidad_iva_id:{required},
      lista_id:{required},
      user_id:{required},
    }
  },
  mounted() {
    this.getResponsabilidadesIva();
    this.getListas();
    this.getUsuarios();
    this.cliente.id = this.$route.params.id;
    this.getCliente();
  },
  methods: {
    getCliente() {
      this.loading = true;
      axios
        .get("/clientes/" + this.cliente.id)
        .then(res => {
          if (res.data.success) {
            this.cliente = res.data.cliente;
          } else {
            Swal.fire({
              icon: "warning",
              title: "Oopss..",
              text: `No se ha encontrado el cliente.`
            });
          }
        })
        .catch(error => {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: `Ha ocurrido un error.`
          });
        })
        .finally(()=>{this.loading=false;});
    },
    guardarCliente() {
      this.enviado = true
      this.loading = true;
      this.$v.$touch();
      if(this.$v.$invalid){
        this.loading = false;
        return false;
      }
      axios
        .put("/clientes/"+this.cliente.id, this.cliente)
        .then(res => {
          if (res.data.success) {
            Swal.fire({
              icon: "success",
              title: "Éxito",
              text: `${res.data.cliente.nombre} se editó con éxito.`
            });
            this.$router.push({ name: "ListarClientes" });
          }
        })
        .catch(error => {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: `No se ha podido completar la operación.`
          });
        })
        .finally(() => (this.loading = false));
    },
    getResponsabilidadesIva() {
      axios.get("/responsabilidades-iva").then(res => {
        for (let iva of res.data) {
          this.responsabilidadesIva.push(iva);
        }
      });
    },
    getListas() {
      axios.get("/listas").then(res => {
        for (let lista of res.data.data) {
          this.listas.push(lista);
        }
      });
    },
    getUsuarios() {
      axios.get("/users").then(res => {
        for (let user of res.data) {
          this.users.push(user);
        }
      });
    }
  }
};
</script>
<style>
  .editr{
    margin-top:4px!important;
    height:80px!important;
  }
  .editr--content{
    cursor:text;
  }
</style>
